import { motion } from "framer-motion";
import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  LAYER_COLORS,
  MODAL_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { HOVER_TRANSITION } from "../../constants/design/motion";
import {
  BORDER_RADIUS,
  COMPONENTS,
  SPACING,
} from "../../constants/design/spacing";

// No `show` prop: it was declared here and read by NOTHING -- the template below
// never interpolates it. Whether the modal is shown is decided by the caller,
// which does not render this element at all when it is closed.
export const ModalWrapper = styled.div`
  /* Fixed so the modal is always centered in the viewport, independent of the
     portal container height or the page content. Previously absolute, which
     mis-centered modals to the top-left when the app content collapsed (e.g. an
     API/CORS error empties the trading page). */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
`;

export const ModalBody = styled(motion.div)<{ $isFullscreen?: boolean }>`
  position: relative;

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      flex: 1;
      height: 100%;
    `}
`;

export const ModalContent = styled(motion.div)<{
  $isFullscreen?: boolean;
}>`
  display: flex;
  flex-direction: column;
  color: ${TEXT_COLORS.one};
  border: 1px solid ${BORDER_COLORS.one};
  border-radius: ${BORDER_RADIUS.five}px;
  background: ${MODAL_COLORS.one};
  overflow: hidden;
  transition: all 0.2s ease-in-out;

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      flex: 1;
      height: 100%;
      border: none;
      border-radius: 0;
    `}
`;

export const Content = styled.div<{
  noPadding?: boolean;
  isFullscreen?: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: ${({ noPadding }) => (noPadding ? 0 : `${SPACING.three}px`)};

  ${({ isFullscreen }) =>
    isFullscreen &&
    css`
      background: green;
      height: 100dvh;
    `}
`;

export const ModalHeader = styled.div`
  height: ${COMPONENTS.modalHeaderHeight}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${BORDER_COLORS.one};
`;

export const CloseButton = styled.button`
  height: ${COMPONENTS.modalHeaderHeight}px;
  width: ${COMPONENTS.modalHeaderHeight}px;
  border-left: 1px solid ${BORDER_COLORS.one};

  /* The dismiss control on EVERY modal had no hover state, so the one thing a
     user reaches for to get out of a dialog gave no sign it was a target.
     It had no pointer cursor either: a button element defaults to
     cursor: default, and the global reset in style.tsx only sets not-allowed
     for :disabled — every other button in the app sets pointer itself, and this
     one never did. */
  cursor: pointer;
  ${HOVER_TRANSITION}

  &:hover {
    background-color: ${LAYER_COLORS.two};
  }

  svg {
    ${HOVER_TRANSITION}
  }

  &:hover svg {
    stroke: ${TEXT_COLORS.one};
  }
`;

export const Title = styled(motion.div)`
  ${FONT_CSS.header.seven}
  padding-left: ${SPACING.three}px;
  text-transform: capitalize;
`;
